export default __webpack_public_path__ + "static/media/TA.b35b1766.svg";